import React from "react"
import PropTypes from "prop-types"
import {Row, Col} from "react-bootstrap"
import styled from "styled-components"

import id from "@irati/utils/id"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {injectIntl} from "@irati/utils/lang"
import {formatDriverName} from "@irati/insights/utils/string"

import DriverButton from "./DriverButton"

import "./bootstrap-5-col.css"


const FlushRow = styled(Row)`
  margin-left: 0;
  margin-right: 0;

  ${minWidthMedia.tablet`
    margin-left: -8px;
    margin-right: -8px;
  `}
`

const FlushCol = styled(Col)`
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-bottom: 0;

  ${minWidthMedia.tablet`
    padding-left: 8px !important;
    padding-right: 8px !important;
    margin-bottom: 16px;
  `}
`


const DriverList = (props) => {
  const idNamespace = id("DriverList", props)
  const {onDriverSelect, formatMessage} = props

  return (
    <FlushRow id={idNamespace}>
      {props.drivers.map((driver) => (
        <FlushCol xs={6} className="col-sm-5ths" key={driver.id}>
          <DriverButton
            id={id(driver.id, idNamespace)}
            driver={driver}
            onClick={() => onDriverSelect(driver)}>
            {formatDriverName(formatMessage, driver)}
          </DriverButton>
        </FlushCol>
      ))}
    </FlushRow>
  )
}


DriverList.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  drivers: PropTypes.array,
  onDriverSelect: PropTypes.func
}

DriverList.defaultProps = {
  drivers: [],
  onDriverSelect: () => {
  }
}

export default injectIntl(DriverList)
